import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class RegistrationsService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getRegistration(registrationId) {
        const url = `${this.urlsService.CLIENT_MANAGEMENT.COLLECTION}/${registrationId}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getRegistrationsList(getParams) {
        const url = this.urlsService.CLIENT_MANAGEMENT.COLLECTION;
        return this.ajaxService.getDataObserveBody(url, getParams);
    }
    createRegistration(payload) {
        const url = this.urlsService.CLIENT_MANAGEMENT.COLLECTION;
        return this.ajaxService.postDataObserveBody(url, payload, undefined, true);
    }
    updateRegistration(registrationId, payload) {
        const url = `${this.urlsService.CLIENT_MANAGEMENT.COLLECTION}/${registrationId}`;
        return this.ajaxService.putDataObserveBody(url, payload, true);
    }
    updateRegistrationStatus(registrationId, status) {
        const url = this.urlsService.getUrl(this.urlsService.CLIENT_MANAGEMENT.STATUS, { registrationId });
        return this.ajaxService.patchJsonDataObserveBody(url, { status }, true);
    }
    updateRegistrationRiskProfile(registrationId, riskProfileId) {
        const url = this.urlsService.getUrl(this.urlsService.CLIENT_MANAGEMENT.SET_RISK_PROFILE, { registrationId });
        return this.ajaxService.patchJsonDataObserveBody(url, { risk_profile_id: riskProfileId }, true);
    }
    getRegistrationHoldings(registrationId, page, resultsPerPage, sortDirection, sortBy, holdingsLayer) {
        const url = this.urlsService.getUrl(this.urlsService.CLIENT_MANAGEMENT.HOLDINGS, {
            registrationId,
        }, {
            page,
            resultsPerPage,
            sortDirection,
            sortBy,
            holdingsLayer,
        });
        return this.ajaxService.getDataObserveBody(url);
    }
    getRegistrationActivities(registrationId, pageNum, resultsPerPage, aggregate, searchTerm) {
        const queryParams = searchTerm !== null
            ? {
                pageNum,
                resultsPerPage,
                aggregate,
                searchTerm,
            }
            : { pageNum, resultsPerPage, aggregate };
        const url = this.urlsService.getUrl(this.urlsService.CLIENT_MANAGEMENT.REGISTRATION_ACTIVITIES, {
            registrationId,
        }, queryParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    getRegistrationRiskHistory(registrationId) {
        const url = this.urlsService.getUrl(this.urlsService.CLIENT_MANAGEMENT.RISK_HISTORY, { registrationId });
        return this.ajaxService.getDataObserveBody(url);
    }
}
RegistrationsService.ɵfac = function RegistrationsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RegistrationsService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
RegistrationsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RegistrationsService, factory: RegistrationsService.ɵfac, providedIn: 'root' });
